import { ParamTimeDependentState } from "./states/TimeDependent";
import { ParamErrorState } from "./states/Error";
export class ParamStatesController {
  constructor(param) {
    this.param = param;
    this.timeDependent = new ParamTimeDependentState(this.param);
    this.error = new ParamErrorState(this.param);
  }
}
